import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Components
import CircularProgress from '@mui/material/CircularProgress';

// Queries
import postGlobal from '../Queries/postGlobal';

// Styles
import styles from './index.module.sass';

export default function AccountToken() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const { t } = useTranslation('accounttoken');
  const { accountToken = '' } = useParams();

  const validateAccount = useCallback(async () => {
    console.log(accountToken);

    let resp;

    const idioma = window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1;
    setLoading(true);
    if (accountToken) {
      resp = await postGlobal({
        tmbservice: 'PostValidarMail',
        jsonBody: {
          idioma,
          token: accountToken,
        },
      });

      console.log(resp);
      const { typeMessage = 'error', message } = resp;

      if (typeMessage !== 'success') {
        alert(message);
        setError(true);
      } else {
        setSuccess(true);
      }
    }
    setLoading(false);
    setTimeout(() => {
      window.location.href = 'https://cart.terramarbrandsusa.com';
    }, 6000);
  }, [accountToken]);

  useEffect(() => {
    validateAccount();
  }, [validateAccount]);

  return (
    <div className={styles.AccountToken}>
      {loading && (
        <div className={styles.loadingMessage}>
          <CircularProgress className={styles.circularProgress} />
          <div className={styles.loaddingText}>{t('loading')}</div>
        </div>
      )}
      {!loading && error && <div className={styles.errorText}>{t('error')}</div>}
      {!loading && success && <div className={styles.successText}>{t('success')}</div>}
      {!loading && (error || success) && (
        <div>
          <div className={styles.loaddingText}>{t('redirect')}</div>
          <div
            className={styles.linkredirect}
            onClick={() => {
              window.location.href = 'https://cart.terramarbrandsusa.com';
            }}>
            {t('linkredirect')}
          </div>
        </div>
      )}
    </div>
  );
}
